// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"141":"99d5eabc","449":"ffe060ca","451":"c319c39a","469":"50cd3383","495":"73d9fa0e","628":"f591c66b","657":"1e596e60","731":"1900eec1"}[chunkId] + ".js";
};